import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=f6fb60d4&scoped=true"
import script from "./Notes.vue?vue&type=script&lang=js"
export * from "./Notes.vue?vue&type=script&lang=js"
import style0 from "./Notes.vue?vue&type=style&index=0&id=f6fb60d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fb60d4",
  null
  
)

export default component.exports